import React from 'react';
import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

interface AddOn {
  name: string;
  description: string;
  price: string;
  icon: string;
  features: string[];
}

const AddOnsSection = () => {
  const addOns: AddOn[] = [
    {
      name: "Extra Training Sessies",
      description: "Aanvullende training voor uw team om optimaal gebruik te maken van AI-tools",
      price: "€350",
      icon: "AcademicCapIcon",
      features: [
        "2 uur persoonlijke training",
        "Op locatie of online",
        "Inclusief trainingsmateriaal",
        "Certificaat van deelname"
      ]
    },
    {
      name: "Priority Support",
      description: "24/7 support met gegarandeerde responstijd van 2 uur",
      price: "€500/mnd",
      icon: "LifebuoyIcon",
      features: [
        "24/7 beschikbaarheid",
        "2 uur responstijd",
        "Dedicated support team",
        "Maandelijkse check-ins"
      ]
    },
    {
      name: "Custom Integratie",
      description: "Maatwerk integratie met uw bestaande systemen en tools",
      price: "Vanaf €1.500",
      icon: "PuzzlePieceIcon",
      features: [
        "Analyse van uw systemen",
        "Custom API ontwikkeling",
        "Testing & implementatie",
        "3 maanden ondersteuning"
      ]
    },
    {
      name: "Advanced Analytics",
      description: "Uitgebreide rapportage en data-analyse voor diepere inzichten",
      price: "€400/mnd",
      icon: "ChartBarIcon",
      features: [
        "Custom dashboards",
        "Predictive analytics",
        "Export naar Excel/PDF",
        "Wekelijkse rapporten"
      ]
    },
    {
      name: "Content Creatie Pakket",
      description: "AI-gegenereerde content voor social media en marketing",
      price: "€600/mnd",
      icon: "PencilSquareIcon",
      features: [
        "20 social media posts",
        "4 blog artikelen",
        "E-mail templates",
        "Visuele content suggesties"
      ]
    },
    {
      name: "White-Label Oplossing",
      description: "Volledig gebrandde AI-oplossing onder uw eigen naam",
      price: "Op aanvraag",
      icon: "TagIcon",
      features: [
        "Uw eigen branding",
        "Custom domein",
        "Dedicated infrastructuur",
        "Volledige controle"
      ]
    }
  ];

  return (
    <section className="py-16 lg:py-24 bg-gradient-to-b from-primary/5 to-transparent">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-display font-bold text-foreground mb-4">
            Extra services & add-ons
          </h2>
          <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
            Breid uw AI-oplossing uit met aanvullende services die perfect aansluiten bij uw behoeften
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-7xl mx-auto">
          {addOns.map((addOn, index) => (
            <div
              key={index}
              className="glassmorphic rounded-2xl p-6 hover:shadow-premium transition-all duration-300 group"
            >
              <div className="flex items-start justify-between mb-4">
                <div className="p-3 rounded-lg bg-primary/10 border border-primary/20 group-hover:bg-primary/20 transition-colors duration-300">
                  <Icon name={addOn.icon as any} size={24} className="text-primary" />
                </div>
                <div className="text-right">
                  <p className="text-2xl font-display font-bold text-primary">{addOn.price}</p>
                  {addOn.price.includes('mnd') && (
                    <p className="text-xs text-muted-foreground">per maand</p>
                  )}
                </div>
              </div>

              <h3 className="text-xl font-display font-bold text-foreground mb-2">
                {addOn.name}
              </h3>
              <p className="text-sm text-muted-foreground mb-4">
                {addOn.description}
              </p>

              <div className="space-y-2 mb-6">
                {addOn.features.map((feature, featureIndex) => (
                  <div key={featureIndex} className="flex items-start space-x-2">
                    <Icon name="CheckIcon" size={16} className="text-success mt-0.5 flex-shrink-0" />
                    <span className="text-sm text-foreground">{feature}</span>
                  </div>
                ))}
              </div>

              <Link
                href="/contact"
                className="block w-full py-2.5 px-4 rounded-lg font-semibold text-sm text-center border border-primary text-primary hover:bg-primary hover:text-primary-foreground transition-all duration-300"
              >
                Meer informatie
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AddOnsSection;